import { postReportResidence } from '@/api';
class ObsServer {
    constructor() {
        this.instanc = null;
        this.watchELInstanc = {};
        this.ELInstancTime = {};
    }
    instanceOBS() {
        this.destroyed();
        this.watchELInstanc = {};
        this.ELInstancTime = {};
        this.instanc = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const entryEl = entry.target;
                if (!entryEl.dataset.types) {
                    console.error('元素缺少 data-types 属性：', entryEl);
                    return;
                }
                if (entry.isIntersecting) {
                    this.watchELInstanc[entryEl.dataset.types] = true;
                    this.ELInstancTime[entryEl.dataset.types] = Date.now();
                }
                else if (this.watchELInstanc[entryEl.dataset.types]) {
                    this.watchELInstanc[entryEl.dataset.types] = false;
                    const endTime = Date.now();
                    const totalTime = (endTime - this.ELInstancTime[entryEl.dataset.types]) / 1000; //秒
                    if (totalTime > 2) {
                        this.fetchTimeData(entryEl.dataset.types, this.ELInstancTime[entryEl.dataset.types]);
                    }
                    else {
                        this.ELInstancTime[entryEl.dataset.types] = 0;
                    }
                }
            });
        }, {
            root: null,
            threshold: 0.9
        });
    }
    watchEL(el) {
        if (!(el instanceof Element)) {
            console.error('传递给 watchEL 的元素无效：', el);
            return;
        }
        if (this.instanc) {
            this.instanc.observe(el);
        }
    }
    formatDateFromTimestamp(timestamp) {
        const date = new Date(timestamp);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始，需 +1
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    fetchTimeData(value, time) {
        const data = {
            entity: value,
            entry_time: this.formatDateFromTimestamp(time)
        };
        postReportResidence(data).then(res => {
        });
    }
    leavePage() {
        const that = this;
        return new Promise(resolve => {
            const noRequestOccurred = Object.keys(that.watchELInstanc).filter(key => that.watchELInstanc[key] === true);
            console.log(that.ELInstancTime, 'ELInstancTime');
            console.log(noRequestOccurred, 'noRequestOccurred');
            if (noRequestOccurred.length === 0) {
                resolve({});
                return;
            }
            ;
            const endTime = Date.now();
            const promises = noRequestOccurred.map(key => {
                const startTime = that.ELInstancTime[key];
                if (startTime === undefined || startTime === null) {
                    console.warn(`Start time for ${key} is undefined or null, skipping...`);
                    return Promise.resolve({});
                }
                const totalTime = (endTime - startTime) / 1000;
                if (totalTime < 2 || startTime === 0) {
                    return Promise.resolve({});
                }
                const data = {
                    entity: key,
                    entry_time: that.formatDateFromTimestamp(startTime)
                };
                delete that.ELInstancTime[key];
                delete that.watchELInstanc[key];
                console.log(data, 'data');
                return postReportResidence(data).catch((error) => {
                    console.error(`Error reporting residence for ${key}:`, error);
                    return {};
                });
            });
            Promise.all(promises).then(responses => {
                resolve(responses);
            }).catch(error => {
                console.error('Error in reporting residences:', error);
                that.watchELInstanc = {};
                that.ELInstancTime = {};
                resolve({});
            });
        });
    }
    /**
     * 页面关闭时同步上报数据（使用 fetch keepalive 保证请求发送）
     * 适用于 pagehide / visibilitychange 等页面卸载场景
     */
    leavePageSync() {
        const noRequestOccurred = Object.keys(this.watchELInstanc).filter(key => this.watchELInstanc[key] === true);
        if (noRequestOccurred.length === 0)
            return;
        const endTime = Date.now();
        const token = sessionStorage.getItem('yc_token') || localStorage.getItem('yc_token') || '';
        // eslint-disable-next-line
        const config = require('../../config');
        const baseURL = config[process.env.NODE_ENV]?.baseURL || '';
        noRequestOccurred.forEach(key => {
            const startTime = this.ELInstancTime[key];
            if (startTime === undefined || startTime === null)
                return;
            const totalTime = (endTime - startTime) / 1000;
            if (totalTime < 2 || startTime === 0)
                return;
            const data = {
                entity: key,
                entry_time: this.formatDateFromTimestamp(startTime)
            };
            try {
                fetch(`${baseURL}/other/report/residence`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    },
                    body: JSON.stringify(data),
                    keepalive: true
                });
            }
            catch (e) {
                console.error('leavePageSync report error:', e);
            }
            delete this.ELInstancTime[key];
            delete this.watchELInstanc[key];
        });
    }
    destroyed() {
        if (this.instanc) {
            console.log("销毁了");
            this.watchELInstanc = {};
            this.ELInstancTime = {};
            this.instanc.disconnect();
        }
    }
}
export default new ObsServer();
